import { connect } from 'react-redux';
import { ManageUserComponent } from './manage-user.component';
import { AppState } from '../../app.state';

/* AER-1694: connect the WithAppConfig(withRouter(...)) wrapped export rather than
   the raw `_ManageuserComponent` class. Connecting the raw class meant WithAppConfig
   never ran for the routed screen, so `this.props.app` was undefined and the Delete
   handler (`this.props.app.modal.confirm`) threw
   "Cannot read properties of undefined (reading 'modal')" before any confirmation
   dialog could render. This mirrors the sibling screens (manage-users, manage-org,
   manage-location, edit-org), which all connect the wrapped export. */
export const ManageUser = connect((sState: AppState) => ({ sState }))(
  ManageUserComponent as any
) as unknown as typeof ManageUserComponent;
